import { Segmented } from 'antd';
import { useMemo } from 'react';

import type { SelectedEmployee } from '@app/components/RecordModal/components/RecordDetails/types';
import { generateEmployeesOptions } from '@app/components/RecordModal/components/RecordDetails/utils';
import type { OtherRecordsInterface } from '@app/types';

import '@app/components/RecordModal/components/RecordDetails/styles/EmployeeTabs.desktop.scss';

import type { FC } from 'react';

interface EmployeeTabsProps {
  employees: OtherRecordsInterface[];
  selectedEmployee: SelectedEmployee;
  onSelectEmployee(employee: SelectedEmployee): void;
  maxWidth: number | null;
  disabled?: boolean;
}

export const EmployeeTabs: FC<EmployeeTabsProps> = ({
  employees,
  selectedEmployee,
  onSelectEmployee,
  maxWidth,
  disabled,
}) => {
  const options = useMemo(
    () => generateEmployeesOptions(employees),
    [employees]
  );

  return (
    <div
      style={{
        maxWidth: maxWidth ? `${maxWidth}px` : '100%',
      }}
      className="employee-tabs__container"
    >
      <Segmented
        value={`${selectedEmployee.RecordId}__${selectedEmployee.EmployeeId}`}
        onChange={(value) => {
          const [RecordId, EmployeeId] = value
            .split('__')
            .map((v) => parseInt(v, 10));
          onSelectEmployee({ RecordId, EmployeeId });
        }}
        options={options}
        className="employee-tabs__segmented"
        disabled={disabled}
      />
    </div>
  );
};
